import { Alert, Flex } from 'antd';
import { t } from 'i18next';
import { ActionStatus } from '@pmp/api';
import { AlertsProps } from '../interfaces';
import styles from '../styles.module.css';

export const Alerts = <EntityCrudData,>({
  status,
  state,
  isUpdateChange,
  isUpdateImportChange,
  processingError,
  invalidationSource,
}: AlertsProps<EntityCrudData>) => {
  return (
    <>
      {(status === ActionStatus.INVALIDATED || invalidationSource) && (
        <Flex style={{ marginBottom: 8 }}>
          <Alert
            message={
              invalidationSource
                ? t('global.labels.changeRequestInvalidatedTooltip', { source: invalidationSource.value })
                : t('global.labels.changeRequestInvalidatedTooltipGeneric')
            }
            type="error"
            showIcon
          />
        </Flex>
      )}
      {processingError && (
        <Flex style={{ marginBottom: 8 }}>
          <Alert message={processingError} type="error" showIcon />
        </Flex>
      )}
      {status === 'APPROVED' && (
        <Flex className={styles.alertRow}>
          <Alert message={t('global.labels.changesWillVoidApproval')} type="warning" showIcon closable />
        </Flex>
      )}
      {(isUpdateChange || isUpdateImportChange) && (
        <Flex className={styles.alertRow}>
          <Alert message={t('global.labels.changesWillBeImmediatelySaved')} type="warning" showIcon closable />
        </Flex>
      )}
      {state.dataSource && state.dataSource.length > 100 && (
        <Flex className={styles.alertRow}>
          <Alert message={t('global.labels.moreThan100rowsSelected', { x: state.dataSource.length })} type="warning" showIcon closable />
        </Flex>
      )}
    </>
  );
};
